import { StyleboardState } from '../../types'

const initialState: StyleboardState = {
  styleboard: undefined,
  myStyleboards: undefined,
  followStyleboards: undefined,
  popularStyleboards: undefined,
  isStyleboardLoading: false,
  hasStyleboardLoadingFailed: false,
  isSimilarItemsLoading: false,
  hasSimilarItemsLoaded: false,
  hasSimilarItemsLoadingFailed: false,
  hasAddItemToboardSucceded: false,
  hasAddItemToboardFailed: false,
  isStyleboardsLoading: false,
  hasStyleboardsLoadingFailed: false,
  hasFollowStyleboardsLoaded: false,
  hasFollowStyleboardsLoadedFailed: false,
  isFollowingStyleboardLoading: false,
  hasFollowingStyleboardLoadingFailed: false,
  notifications: [],
  isUploadingImageLoading: false,
  hasUploadingImageSucceded: false,
  hasUploadingImageFailed: false,
  individualItemId: '',
  isDeletionItemLoading: false,
  hasDeletedItemSucceded: false,
  hasDeletedItemFailed: false,
  isDeletingStyleboardLoading: false,
  hasDeletedStyleboardSucceded: false,
  hasDeletedStyleboardFailed: false,
  hasPopularStyleboardsLoaded: false,
  hasPopularStyleboardsLoadedFailed: false,
  publicStyleboards: undefined,
  isPublicStyleboardsLoading: false,
  hasPublicStyleboardsLoadingFailed: false,
}

export default initialState
